'use client';
import { useEffect } from 'react';
import { useParams } from 'next/navigation';
import { Box, Typography } from '@mui/material';
import withResourceAuth from '@/components/auth/withResourceAuth';
import DataTreeArea from '@/components/dataTree/DataTreeArea';
import { DataPackageKeyProvider } from '@/api/AuthorizedApiBase';

function DataPage() {
  const params = useParams();
  const id = params?.['id'] ? params['id'] : [];

  // Join the id array to form the full id
  const fullId = Array.isArray(id) ? id.join('/') : id;

  useEffect(() => {
    if (fullId) {
      DataPackageKeyProvider.setKey(fullId);
    } else {
      DataPackageKeyProvider.clear();
    }
    return () => DataPackageKeyProvider.clear();
  }, [fullId]);

  if (!fullId) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography variant="h6" color="text.secondary">
          Please select a data package to view
        </Typography>
      </Box>
    );
  }

  return <DataTreeArea dataId={fullId} />;
}

export default withResourceAuth(DataPage, {
  resourceType: 'data',
  route: 'data',
});
